import { AxiosRequest } from "_services/api";
import { IOptions } from "components/DropdownSelect";
import { useEffect, useMemo, useState } from "react";
import { TipoSolicitacaoPlaca } from "../constants/tipoSolicitacaoPlaca";

interface IUsuario {
  id: number;
  nome: string;
}

export function useUsuariosSolicitacaoPlaca(tipo?: TipoSolicitacaoPlaca) {
  const msAw = useMemo(
    () => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW),
    []
  );
  const [usuariosOptions, setUsuariosOptions] = useState<IOptions[]>([]);

  useEffect(() => {
    const parametros = tipo ? `?${new URLSearchParams({ tipo })}` : "";

    msAw
      .get(`/solicitacao-placa/lote/usuarios${parametros}`)
      .then(({ data }) =>
        setUsuariosOptions(
          (data ?? []).map(({ id, nome }: IUsuario) => ({
            value: id,
            label: nome,
          }))
        )
      )
      .catch(() => setUsuariosOptions([]));
  }, [msAw, tipo]);

  return { usuariosOptions };
}
